import { useEffect, useRef } from 'react';

function Modal(props) {
	const modalRef = useRef(null);

	useEffect(() => {
		getMountMethods();

		document.addEventListener('mousedown', handleOverlayClick);

		return () => {
			document.removeEventListener('mousedown', handleOverlayClick);
			getUnMountMethods();
		};
	}, []);

	function handleOverlayClick(event) {
		if (modalRef.current && !modalRef.current.contains(event.target)) {
			if (props.onClose) {
				props.onClose();
				return;
			}

			props.onCloseSuccess();
		}
	}

	function getChildren() {
		return props.children ? (
			<div className="my-4 rich-text container-sm text-center">
				{props.children}
			</div>
		) : null;
	}

	function getMountMethods() {
		togglePageOverflow('hidden');
	}

	function getUnMountMethods() {
		togglePageOverflow('scroll');
	}

	function togglePageOverflow(overflow) {
		const body = document.getElementById('root');
		if (body) {
			body.style.overflow = overflow;
		}
	}

	return (
		<>
			<div
				aria-hidden="true"
				className="absolute top-0 left-0 z-10 h-full w-full bg-black bg-opacity-20"
			/>
			<div
				aria-labelledby="modal_label"
				aria-modal="true"
				className="message-popover"
				ref={modalRef}
				role="dialog"
			>
				<section className="message centered bg-white my-5">
					{getChildren()}
				</section>
			</div>
		</>
	);
}

export default Modal;
